/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_Video_TitleInputs */

const en_us2_share_video_title = /** @type {(inputs: Share_Video_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retrospective video`)
};

const pt_br2_share_video_title = /** @type {(inputs: Share_Video_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vídeo da Retrospectiva`)
};

const es_419_share_video_title = /** @type {(inputs: Share_Video_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video de la Retrospectiva`)
};

const pt_pt2_share_video_title = /** @type {(inputs: Share_Video_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vídeo da Retrospetiva`)
};

const fr_fr2_share_video_title = /** @type {(inputs: Share_Video_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vidéo rétrospective`)
};

const de_de2_share_video_title = /** @type {(inputs: Share_Video_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rückblick-Video`)
};

const it_it2_share_video_title = /** @type {(inputs: Share_Video_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video riepilogo`)
};

/**
* | output |
* | --- |
* | "Retrospective video" |
*
* @param {Share_Video_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const share_video_title = /** @type {((inputs?: Share_Video_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_Video_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_share_video_title(inputs)
	if (locale === "es-419") return es_419_share_video_title(inputs)
	if (locale === "pt-PT") return pt_pt2_share_video_title(inputs)
	if (locale === "fr-FR") return fr_fr2_share_video_title(inputs)
	if (locale === "de-DE") return de_de2_share_video_title(inputs)
	if (locale === "it-IT") return it_it2_share_video_title(inputs)
	return en_us2_share_video_title(inputs)
});
export { share_video_title as "share.video_title" }